import { Navigate } from "react-router-dom";
import TokenService from "../utils/TokenService";
import { useLocation } from 'react-router-dom';
const PrivateRoute = ({ children }) => {
    const location = useLocation();
    if (!TokenService.isLoggedIn()) {
        if (TokenService.isPendingEmailVerification()) {
            return <Navigate to="/verify-email" />;
        }
        else {
            TokenService.setRedirectOnLogin(window.location.href);
            return <Navigate to="/" />;
        }
    }
    else {
        if (location.pathname.toLowerCase().startsWith("/account/admin")) {
            if (!TokenService.isWallistAdmin()) {
                return <Navigate to="/account/select-provider" />;
            }
        }
    }
    return children;
};

export default PrivateRoute;
